module.exports = __webpack_public_path__ + "static/assets/39f37f1b00fbf96926276701d8de4c89.png";